import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { CharterersPage } from '../pages/Charterers/CharterersPage';
import { ContractsPage } from '../pages/Contracts/ContractsPage';
import { DashboardPage } from '../pages/Dashboard/DashboardPage';
import { EmissionFactorsPage } from '../pages/EmissionFactors/EmissionFactorsPage';
import EntitiesPage from '../pages/Entities/EntitiesPage';
import { InvoicesPage } from '../pages/Invoices/InvoicesPage';
import { ProcurementsPage } from '../pages/Procurements/ProcurementsPage';
import { SettingsPage } from '../pages/Settings/SettingsPage';
import { UsersPage } from '../pages/Users/UsersPage';
import { VesselsPage } from '../pages/Vessels/VesselsPage';
import { VoyagesPage } from '../pages/Voyages/VoyagesPage';
import { VesselVoyageXlsUploadPage } from '../pages/Xls/VesselVoyageXlsUploadPage';
import MarketInsightsPage from '../pages/MarketInsights/MarketInsightsPage';
import { DemoAccountsPage } from '../pages/DemoAccounts';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="entities" element={<EntitiesPage />} />
        <Route path="demo-accounts" element={<DemoAccountsPage />} />
        <Route path="vessels" element={<VesselsPage />} />
        <Route path="voyages" element={<VoyagesPage />} />
        <Route path="charterers" element={<CharterersPage />} />
        <Route path="contracts" element={<ContractsPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="procurements" element={<ProcurementsPage />} />
        <Route path="emission-factors" element={<EmissionFactorsPage />} />
        <Route path="market-insights" element={<MarketInsightsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="vessel-voyage-xls-upload" element={<VesselVoyageXlsUploadPage />} />
      </Route>
    </Routes>
  );
}
